var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'color-' + _vm.randomInt(4)},[_c('span',[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }